import React from 'react';
import TitleWithCrumb from './TitleWithCrumb';
import { cn } from '../utils/cn';
import './PageHeader.css';

/**
 * PAGE HEADER — the standard "top of page" block: breadcrumb + title (via
 * TitleWithCrumb) + subtitle, laid out in a row with a generic `slot` on the
 * right.
 *
 * `slot` is intentionally untyped/unopinionated — it's just a ReactNode hole.
 * PageHeader has no idea what's inside and should stay that way: don't add
 * props for whatever happens to live there today. Keep it generic.
 *
 * Ported from the reporting UI; styled with plain CSS on tokens.css.
 *
 * @param {React.ReactNode} title
 * @param {React.ReactNode} [subtitle]
 * @param {React.ReactNode} [slot] - rendered to the right of title/subtitle
 * @param {string} [returnTo] / @param {React.ReactNode} [returnLabel] - optional parent crumb
 */
export default function PageHeader({ title, subtitle, slot, returnTo, returnLabel, className }) {
  return (
    <div className={cn('ph', className)}>
      <div className="ph-main">
        <TitleWithCrumb title={title} returnTo={returnTo} returnLabel={returnLabel} />
        {subtitle ? <p className="ph-subtitle">{subtitle}</p> : null}
      </div>
      {slot ? <div className="ph-slot">{slot}</div> : null}
    </div>
  );
}
